__turbopack_context__.v({
  "appButtonBadge": "snapshotAppFooter-module-scss-module__ZJr14q__appButtonBadge",
  "footer": "snapshotAppFooter-module-scss-module__ZJr14q__footer",
  "footerHeading": "snapshotAppFooter-module-scss-module__ZJr14q__footerHeading",
});
